
import React, { useState, useEffect } from 'react';
import { updateSEO, addJsonLd } from '../../utils/seo';

const B2BPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('designers');

  const openQuiz = (clientType?: string) => {
    const message = clientType 
      ? `Здравствуйте! Я ${clientType}. Интересуют условия сотрудничества и специальные цены.`
      : 'Здравствуйте! Интересуют условия для B2B сотрудничества.';
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/77085773668?text=${encodedMessage}`, '_blank');
  };

  useEffect(() => {
    // Update SEO
    updateSEO({
      title: 'B2B сотрудничество - Для дизайнеров, архитекторов и строителей | MUSLIM CERAMICA',
      description: 'Специальные условия для профессионалов: дизайнеров, архитекторов, строительных компаний и дилеров. Персональные скидки до 15%, техническая поддержка, быстрая логистика.',
      keywords: 'B2B керамогранит, для дизайнеров, для строителей, дилерская программа, оптовые цены керамогранит, партнерство',
      canonical: '/b2b'
    });

    // Add Service Schema
    addJsonLd({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "B2B сотрудничество MUSLIM CERAMICA",
      "description": "Специальные программы сотрудничества для дизайнеров, архитекторов, строительных компаний и дилеров",
      "provider": {
        "@type": "Organization",
        "name": "MUSLIM CERAMICA",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "ул. Карбышева 8/1",
          "addressLocality": "Костанай",
          "addressCountry": "KZ"
        },
        "telephone": "+7 708 577-36-68"
      },
      "serviceType": "B2B поставки керамогранита",
      "areaServed": "Костанайская область",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "B2B программы",
        "itemListElement": [
          {
            "@type": "Offer",
            "name": "Программа для дизайнеров",
            "description": "Персональные скидки до 15%, 3D-визуализация, образцы"
          },
          {
            "@type": "Offer", 
            "name": "Программа для строителей",
            "description": "Оптовые цены от 1000 м², поэтапная поставка, техподдержка"
          },
          {
            "@type": "Offer",
            "name": "Дилерская программа", 
            "description": "Эксклюзивные территории, обучение, маркетинговая поддержка"
          }
        ]
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: 'linear-gradient(rgba(34, 197, 94, 0.85), rgba(21, 128, 61, 0.85)), url("https://public.readdy.ai/ai/img_res/93ff9d70625cc65e8b694bedbc50b8aa.jpg")'
        }}
      >
        <div className="container mx-auto px-6 text-white w-full">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Для дизайнеров, архитекторов и строителей
            </h1>
            <p className="text-xl md:text-2xl mb-4 text-green-50">
              Специальные условия для профессионалов. Персональные скидки, техническая поддержка, быстрая логистика по области.
            </p>
            <p className="text-lg md:text-xl mb-8 text-green-100 font-semibold">
              🏗️ Работаем с объектами любой сложности — от квартир до ЖК
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => openQuiz('дизайнер/архитектор')}
                className="bg-white text-green-700 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                🎨 Условия для дизайнеров
              </button>
              <button 
                onClick={() => openQuiz('строительная компания')}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-green-700 transition-colors text-center whitespace-nowrap"
              >
                🏢 Условия для строителей
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-green-700 mb-4">Специальные программы сотрудничества</h2>
            <p className="text-xl text-gray-600">Выберите вашу сферу деятельности</p>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-8">
            <div className="bg-white rounded-full p-1 shadow-md">
              <button 
                onClick={() => setActiveTab('designers')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap ${
                  activeTab === 'designers' 
                    ? 'bg-green-600 text-white' 
                    : 'text-green-600 hover:bg-green-50'
                }`}
              >
                🎨 Дизайнеры и архитекторы
              </button>
              <button 
                onClick={() => setActiveTab('builders')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap ${
                  activeTab === 'builders' 
                    ? 'bg-green-600 text-white' 
                    : 'text-green-600 hover:bg-green-50'
                }`}
              >
                🏗️ Строительные компании
              </button>
              <button 
                onClick={() => setActiveTab('dealers')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap ${
                  activeTab === 'dealers' 
                    ? 'bg-green-600 text-white' 
                    : 'text-green-600 hover:bg-green-50'
                }`}
              >
                🤝 Дилеры и партнеры
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'designers' && (
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-green-700 mb-6">Программа для дизайнеров</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-percent-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Персональные скидки до 15%</h4>
                      <p className="text-gray-600">Специальные цены для дизайнеров и архитекторов</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-palette-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">3D-визуализация проектов</h4>
                      <p className="text-gray-600">Помощь в создании реалистичных визуализаций</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-book-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Каталоги и образцы</h4>
                      <p className="text-gray-600">Бесплатные образцы для презентации клиентам</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-customer-service-2-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Персональный менеджер</h4>
                      <p className="text-gray-600">Индивидуальное сопровождение каждого проекта</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-time-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Приоритетная доставка</h4>
                      <p className="text-gray-600">Быстрая доставка в удобное время</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <button 
                    onClick={() => openQuiz('дизайнер')}
                    className="bg-green-600 текст-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    🎨 Стать партнером-дизайнером
                  </button>
                </div>
              </div>
              <div className="relative h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Interior%20designer%20working%20in%20Kostanay%20Kazakhstan%20showroom%20with%20ceramic%20tile%20samples%2C%20modern%20design%20studio%20in%20Kostanay%2C%20professional%20designer%20selecting%20premium%20tiles%20from%20local%20warehouse&width=600&height=400&seq=kostanay-designer-work&orientation=landscape"
                  alt="Дизайнеры за работой"
                  className="w-full h-full object-cover rounded-lg shadow-lg object-top"
                />
              </div>
            </div>
          )}

          {activeTab === 'builders' && (
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Construction%20site%20in%20Kostanay%20Kazakhstan%20with%20professional%20builders%20installing%20ceramic%20tiles%2C%20modern%20residential%20building%20construction%20in%20Kostanay%20city%2C%20construction%20workers%20laying%20premium%20floor%20tiles&width=600&height=400&seq=kostanay-builders-work&orientation=landscape"
                  alt="Строительные работы"
                  className="w-full h-full object-cover rounded-lg shadow-lg object-top"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-green-700 mb-6">Программа для строителей</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-building-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Оптовые цены от 1000 м²</h4>
                      <p className="text-gray-600">Максимальные скидки для крупных объектов</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-calendar-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Поэтапная поставка</h4>
                      <p className="text-gray-600">Доставка материала по графику строительства</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-file-text-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Полный пакет документов</h4>
                      <p className="text-gray-600">Сертификаты, паспорта качества, инструкции</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-shield-check-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Гарантия качества</h4>
                      <p className="text-gray-600">Замена бракованного товара за наш счет</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-tools-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Техническая поддержка</h4>
                      <p className="text-gray-600">Консультации по укладке и применению</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <button 
                    onClick={() => openQuiz('строительная компания')}
                    className="bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    🏗️ Стать партнером-подрядчиком
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'dealers' && (
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-green-700 mb-6">Дилерская программа</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-map-2-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Эксклюзивные территории</h4>
                      <p className="text-gray-600">Закрепление районов Костанайской области</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-graduation-cap-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Обучение продажам</h4>
                      <p className="text-gray-600">Тренинги по продуктам и техникам продаж</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-megaphone-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Маркетинговая поддержка</h4>
                      <p className="text-gray-600">Рекламные материалы, баннеры, каталоги</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-truck-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Логистическая поддержка</h4>
                      <p className="text-gray-600">Быстрая доставка по Костанайской области</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-money-dollar-circle-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Отсрочка платежа</h4>
                      <p className="text-gray-600">Гибкие условия оплаты для постоянных партнеров</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <button 
                    onClick={() => openQuiz('потенциальный дилер')}
                    className="bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    🤝 Стать дилером
                  </button>
                </div>
              </div>
              <div className="relative h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20tile%20showroom%20in%20Kostanay%20Kazakhstan%20with%20business%20partners%20meeting%2C%20modern%20ceramic%20tile%20retail%20store%20in%20Kostanay%2C%20successful%20business%20partnership%20in%20Kostanay%20region&width=600&height=400&seq=kostanay-partnership&orientation=landscape"
                  alt="Партнерство"
                  className="w-full h-full object-cover rounded-lg shadow-lg object-top"
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-green-700 mb-12">Реализованные проекты</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20residential%20complex%20lobby%20in%20Kostanay%20Kazakhstan%20with%20premium%20ceramic%20tiles%2C%20elegant%20apartment%20building%20entrance%20hall%20in%20Kostanay%20city%2C%20luxury%20floor%20tiles%20installation&width=400&height=300&seq=kostanay-residential-project&orientation=landscape"
                alt="Жилой комплекс"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-800">Жилой комплекс</h3>
                <p className="text-gray-600 mb-3">120 квартир, 8500 м² керамогранита</p>
                <div className="text-sm text-gray-500">
                  <p>• Формат: 60×60, 120×60</p>
                  <p>• Срок поставки: 2 недели</p>
                  <p>• Специальные условия</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20shopping%20mall%20interior%20in%20Kostanay%20Kazakhstan%20with%20premium%20ceramic%20floor%20tiles%2C%20commercial%20space%20in%20Kostanay%20city%20with%20elegant%20tile%20flooring%2C%20retail%20center%20with%20professional%20tile%20installation&width=400&height=300&seq=kostanay-commercial-project&orientation=landscape"
                alt="Торговый центр"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-800">Торговый центр</h3>
                <p className="text-gray-600 mb-3">Торговые площади, 12000 м² антискользящего керамогранита</p>
                <div className="text-sm text-gray-500">
                  <p>• Повышенная износостойкость</p>
                  <p>• Антискользящее покрытие</p>
                  <p>• Поэтапная поставка</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20hospital%20interior%20in%20Kostanay%20Kazakhstan%20with%20hygienic%20ceramic%20wall%20tiles%2C%20medical%20facility%20in%20Kostanay%20city%20with%20professional%20tile%20installation%2C%20healthcare%20building%20interior&width=400&height=300&seq=kostanay-medical-project&orientation=landscape"
                alt="Медицинское учреждение"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-800">Медицинское учреждение</h3>
                <p className="text-gray-600 mb-3">Реконструкция, 6500 м² гигиенической плитки</p>
                <div className="text-sm text-gray-500">
                  <p>• Медицинские стандарты</p>
                  <p>• Антибактериальное покрытие</p>
                  <p>• Полный пакет сертификатов</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-green-700">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">Почему профессионалы выбирают нас</h2>
            <p className="text-xl text-green-100">7 лет успешной работы с B2B клиентами</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Быстрые сроки</h3>
              <p className="text-green-100">Поставка в течение 1-3 дней по Костанайской области</p>
            </div>
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Гарантия качества</h3>
              <p className="text-green-100">Заводская гарантия и замена брака за наш счет</p>
            </div>
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Поддержка 24/7</h3>
              <p className="text-green-100">Персональный менеджер для каждого крупного проекта</p>
            </div>
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-percent-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Лучшие цены</h3>
              <p className="text-green-100">Прямые поставки от заводов без посредников</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-green-700 mb-6">Готовы начать сотрудничество?</h2>
          <p className="text-xl text-gray-600 mb-8">Получите персональное предложение уже сегодня</p>
          <div className="flex flex-col sm-flex-row gap-4 justify-center">
            <button 
              onClick={() => openQuiz()}
              className="bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              💼 Получить коммерческое предложение
            </button>
            <a 
              href="https://wa.me/77085773668"
              className="border-2 border-green-600 text-green-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 hover:text-white transition-colors whitespace-nowrap"
            >
              📱 Связаться в WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default B2BPage;
